import React from 'react'

import { GenericError } from '@sketch/components'

import { PublicationQueryPreferencesFragment } from '@sketch/gql-types'

import PublicationList, { PublicationListPlaceholder } from '../PublicationList'
import { useGetCommunityPublications } from '../../hooks/useGetCommunityPublications'

interface CommunityPublicationListingProps {
  preferences: Partial<PublicationQueryPreferencesFragment> | null
}

const CommunityPublicationListing = (
  props: CommunityPublicationListingProps
) => {
  const { preferences } = props

  const { data, loading, error } = useGetCommunityPublications({
    preferences,
  })

  if (loading) {
    return <PublicationListPlaceholder />
  }

  if (error || !data) {
    return <GenericError />
  }

  const publications = data.publications
  const items = publications.entries || []

  return <PublicationList items={items} />
}

export default CommunityPublicationListing
